const STORAGE_KEY = 'workloop.audioCaptionEnabled';
const EVENT_NAME = 'workloop:audio-caption-prefs-changed';

let cache = null;

const readEnabled = () => {
  if (cache !== null) return cache;
  try {
    cache = localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    cache = false;
  }
  return cache;
};

const writeEnabled = (enabled) => {
  cache = Boolean(enabled);
  try {
    localStorage.setItem(STORAGE_KEY, cache ? 'true' : 'false');
  } catch {
    // ignore quota
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { enabled: cache } }));
  }
};

export const isAudioCaptionEnabled = () => readEnabled();

export const setAudioCaptionEnabled = (enabled) => {
  writeEnabled(enabled);
  return readEnabled();
};

export const subscribeAudioCaptionEnabled = (listener) => {
  const onChange = () => listener(readEnabled());
  window.addEventListener(EVENT_NAME, onChange);
  return () => window.removeEventListener(EVENT_NAME, onChange);
};
